<template>
  <div class="record">
    <headd :mobile_title="mobile_title"></headd>

    <div style="margin-top:0.32rem">
      <div class="coupon_title  hidden-sm hidden-xs">代开票申请</div>
      <div
        class="box_con container"
        v-for="(item, index) in myInvoiceQuery"
        :key="index"
      >
        <div class="info_data">
          <div class="data_head" @click="open" :data-index="index">
            <div class="data_title">
              <div class="line"></div>
              {{ item.showtitle }}
            </div>
            <div class="arrow_right">
              {{ item.showstatus
              }}<img class="img" src="../../../static/user/icon_9.png" />
            </div>
          </div>
          <div v-show="index == isChange" style="flex-direction: column;">
            <div class="info_item">
              <div class="ii_title">销货单位/承运方</div>
              <div class="ii_cell">单位名称: {{ item.sales_title }}</div>
              <div class="ii_cell">税号： {{ item.sales_code }}</div>
              <div class="ii_cell">开票抬头: {{ item.buyer_title }}</div>
            </div>
            <div class="info_item">
              <div class="ii_title">明细</div>
              <div class="ii_cell">
                金额合计 ：<span class="red">{{ item.all_price }}</span> 元
              </div>
              <div
                v-for="(item_2, index) in JSON.parse(item.itemdesc)"
                :key="index"
              >
                <div class="ii_cell">名称：{{ item_2.itemtitle }}</div>
                <div class="ii_cell">规格型号：{{ item_2.model }}</div>
                <div class="ii_cell">单位：{{ item_2.unit }}</div>
                <div class="ii_cell">数量：{{ item_2.num }}</div>
                <div class="ii_cell">
                  单价：<span class="red">{{ item_2.price }}</span
                  >元
                </div>
                <div class="ii_cell">
                  金额：<span class="red">{{ item_2.price * item_2.num }}</span
                  >元
                </div>
              </div>
            </div>
            <div class="info_item">
              <div class="ii_title">收款人：{{ item.payee }}</div>
              <div class="ii_cell">
                配送地址：{{ item.express_province }}{{ item.express_city
                }}{{ item.express_address }}
              </div>
              <div class="ii_cell">联系人：{{ item.express_name }}</div>
              <div class="ii_cell">电话号码：{{ item.express_tel }}</div>
              <div class="ii_cell">备注：{{ item.remark }}</div>
              <div class="ii_cell">提交时间：{{ item.createdAt }}</div>
              <div class="ii_cell" v-if="item.apply_status == 1">
                开票时间：{{ item.optAt }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gomore" @click="morelist" v-show="!flag">加载更多</div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { getmyInvoiceQuery } from "../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
export default {
  data() {
    return {
      mobile_title: "代开票申请",
      status_open: false,
      isChange: -1,
      pageindex: 1,
      flag: false,
      myInvoiceQuery: []
    };
  },
  components: {
    headd,
    foot
  },
  mounted() {
    this.getmyInvoiceQuerylist();
  },
  methods: {
    open(e) {
      var _self = this;
      var index = e.currentTarget.dataset.index;
      if (index != _self.isChange) {
        _self.isChange = index;
      } else {
        _self.isChange = -1; //不注释则可以点击取消，注释之后点击就不再取消
      }
    },
    async getmyInvoiceQuerylist() {
      var _slef = this;
      var data = {
        uid: localStorage.getItem("userId"),
        page: _slef.pageindex,
        limit: 10
      };
      const res = await getmyInvoiceQuery(data);

      _slef.myInvoiceQuery = _slef.myInvoiceQuery.concat(res.data.data);

      if (res.data.data.length < 10) {
        _slef.flag = true;
      }
    },
    morelist() {
      if (!this.flag) {
        this.pageindex++;
        this.getmyInvoiceQuerylist();
      }
    }
  }

  //   onShow() {
  //     this.myInvoiceQuery = [];
  //     this.pageindex = 1;
  //     (this.flag = false), this.getmyInvoiceQuery();
  //   },
  //   onReachBottom() {
  //     if (!this.flag) {
  //       this.pageindex++;
  //       this.getmyInvoiceQuery();
  //     }
  //   }
};
</script>

<style lang="less" scoped>
page {
  background-color: #f2f2f2;
}

.record {
  margin: 0 auto;
  flex-direction: column;
  text-align: left;
  .coupon_title {
    font-size: 0.26rem;
    margin: 0.32rem auto;
    width: 8rem;
    text-align: left;
  }

  .select {
    margin: 37rpx 32rpx;
    width: 626rpx;
    height: 70rpx;
    background: #ffffff;
    border-radius: 35rpx;
    align-items: center;
    justify-content: space-between;
    padding: 0 30rpx;
    font-size: 30rpx;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1b1c33;

    .icon {
      width: 30rpx;
      height: 17rpx;
    }
  }
}

.box_con {
  margin: 0rem auto 0.2rem auto;
  width: 8rem !important;
  background-color: rgba(196, 196, 204, 0.1);
  border-radius: 0.3rem;
  padding: 0.2rem 0;
  border: 0;
  @media (max-width: 991px) {
    width: 6.86rem !important;
  }
  cursor: pointer;
  .info_data {
    flex-direction: column;

    .data_head {
      align-items: center;
      justify-content: space-between;
      padding: 0 0.2rem;
      display: flex;
      margin-bottom: 0;
      @media (max-width: 991px) {
        padding: 0.12rem 0.2rem;
      }
      .data_title {
        font-size: 0.16rem;
        font-weight: bolder;
        color: #1b1c33;
        line-height: 0.25rem;
        @media (max-width: 991px) {
          font-size: 0.3rem;
          line-height: 0.42rem;
        }

        .line {
          width: 0.05rem;
          height: 0.26rem;
          background: #1395ff;
          border-radius: 0.03rem;
          margin-right: 0.05rem;
        }
      }

      .arrow_right {
        font-size: 0.16rem;
        color: #1395ff;
        line-height: 0.25rem;
        align-items: center;
        width: auto;
        @media (max-width: 991px) {
          font-size: 0.28rem;
          line-height: 0.42rem;
          height: auto;
        }

        .img {
          margin-left: 0.1rem;
          width: 0.2rem;
          height: 0.11rem;
        }
      }

      .data_right {
        font-size: 22rpx;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #8d8e99;
        line-height: 30rpx;

        .right {
          font-size: 28rpx;
          color: #ff545a;
        }
      }
    }

    .data_sn {
      height: 0.3rem;
      font-size: 0.2rem;
      color: #8d8e99;
      line-height: 0.3rem;
      margin-bottom: 0.2rem;
    }
  }
}

.info_item {
  //   border-top: 0.01rem solid #eeeeee;
  margin: 0.2rem 0 0rem 0;
  padding: 0.1rem 0.2rem;
  flex-direction: column;
  border-bottom: 0.01rem solid #eeeeee;
  display: flex;
  .ii_title {
    height: 0.25rem;
    font-size: 0.16rem;
    font-weight: bolder;
    color: #1395ff;
    line-height: 0.25rem;
    margin-bottom: 0.19rem;
    @media (max-width: 991px) {
      height: 0.33rem;
      font-size: 0.26rem;
    }
  }

  .ii_cell {
    height: auto;
    font-size: 0.16rem;
    color: #1b1c33;
    line-height: 0.25rem;
    margin-bottom: 0.2rem;
    @media (max-width: 991px) {
      height: 0.33rem;
      font-size: 0.26rem;
    }

    .red {
      color: #ff545a;
    }
  }

  &:last-child {
    border-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/record/record.vue